export const formatUserFullname = (
  user: Partial<{ firstName?: string; lastName?: string }>,
): string => {
  return `${user.firstName || ''} ${user.lastName || ''}`;
};

export default { formatUserFullname };
